import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { onErrorCaptured, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorGuard',
  props: {
    message: {}
  },
  setup(__props: any) {



const error = ref(false);
onErrorCaptured(() => (error.value = true));

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "wrapper", { error: error.value }, () => [
    (error.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
          _renderSlot(_ctx.$slots, "error", {}, () => [
            _createTextVNode(_toDisplayString(_ctx.message || 'Whoops, an error occurred!'), 1)
          ])
        ]))
      : _renderSlot(_ctx.$slots, "default", { key: 1 })
  ])
}
}

})